module.exports = __webpack_public_path__ + "img/logo-ivi-blanco.a7d1be08.svg";